import { DEFAULT_VARIATION_ID, OLD_DEFAULT_VARIATION_ID } from './constants';

export const isDefaultVariation = (variationId: string) =>
  variationId === DEFAULT_VARIATION_ID || variationId === OLD_DEFAULT_VARIATION_ID;
